import { MDBRow, MDBCol } from "mdb-react-ui-kit";
import VisionImg from "../asset/images/BGImages/vision.jpg";
export default function Vision(props) {
    return (
        <div className="w-100" style={{ height: "50%", backgroundColor: "#eceff1" }} id="vision">
            <MDBRow className="mx-0" style={{ height: "100%", overflowY: "auto" }} id="lRow">
                <MDBCol lg="6" className="h-100 d-flex flex-column justify-content-center align-items-center" id="lCol">
                    <h2 className=" display-5 fw-bold text-start theme-color py-3 w-75 mb-4">Our Vision</h2>

                    <p className="fs-3 w-75">
                        To attain globally best standards and become a world-class financial services enterprise –
                        guided by its purpose to move towards a greater degree of sophistication and maturity.
                    </p>
                </MDBCol>
                <MDBCol lg="6" className="h-100 d-flex justify-content-center align-items-center py-3" id="lCol">
                    <img src={VisionImg} className="rounded-5" style={{ height: "100%", width: "100%", objectFit: "cover" }} />
                </MDBCol>
            </MDBRow>
        </div>
    )
}